export function limitLength(text: string, length: number) {
    return text.length > length ? `${text.substr(0, length-3)}...` : text;
}